import { render, staticRenderFns } from "./form-gdpr.vue?vue&type=template&id=ac8d44d8&"
import script from "./form-gdpr.vue?vue&type=script&lang=js&"
export * from "./form-gdpr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports